import { ca } from '@cian/analytics';

export function caShowFirstQuestion() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Open',
    category: 'Listing Card',
    label: 'poll/popup_step_1',
  });
}

export function caShowSecondQuestion() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Open',
    category: 'Listing Card',
    label: 'poll/popup_step_2',
  });
}

export function caOpenThankYouModal() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Open',
    category: 'Listing Card',
    label: 'poll/success_popup',
  });
}

export function caCloseQuiz() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'Listing Card',
    label: 'poll/close_button',
  });
}
